import { defineComponent, computed, toRefs } from "@vue/composition-api";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { useI18n } from "vue-i18n-composable";
import { useMultipleSelect } from "@Shared/@Composables/generic/useMultipleSelect";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
export default defineComponent({
  name: "SelectFormat",
  components: {
    MaterialInput,
    vSelectField
  },
  props: {
    selectedFormat: {
      type: [String, Array],
      required: true,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const {
      selectedFormat,
      multiple
    } = toRefs(props);
    const {
      handleSelectMultipleChange
    } = useMultipleSelect();
    const formatOptions = computed(() => [{
      id: "pdf",
      text: "PDF"
    }, {
      id: "csv",
      text: "CSV"
    }]);
    const localSelectedFormat = computed({
      get() {
        var _selectedFormat$value;
        return (_selectedFormat$value = selectedFormat.value) != null ? _selectedFormat$value : multiple.value ? [] : "";
      },
      set(newValue) {
        emit("update:selectedFormat", newValue);
      }
    });
    const options = computed(() => ({
      placeholder: t("global.actions.chooseOption")
    }));
    const handleChange = (selectedValue, type) => {
      localSelectedFormat.value = handleSelectMultipleChange(selectedValue, type, localSelectedFormat.value, multiple.value);
    };
    return {
      formatOptions,
      localSelectedFormat,
      options,
      handleChange
    };
  }
});